export const ExternalLinks = {
  CONTACT: 'https://oceaneyes.co.jp/fnavisupport',
  LINE_ACCOUNT: 'https://page.line.me/884ooqmy?openQrModal=true',
  PRIVACY_POLICY: 'https://oceaneyes.co.jp/privacypolicy',
  SUPPORT_EMAIL: 'mailto: support@oceaneyes.co.jp',
  TERMS_OF_SERVICE: 'https://oceaneyes.co.jp/terms_fnavistd',
};
